import script from "./DefaultPreloader.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultPreloader.vue?vue&type=script&setup=true&lang=js"

import "./DefaultPreloader.vue?vue&type=style&index=0&id=0751f25a&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0751f25a"]])

export default __exports__